import { useEffect } from 'react'
import useCheckAuth from '@src/hooks/auth/checkAuth/useCheckAuth'
import { useLocation, useNavigate } from 'react-router-dom'

const AuthChecker = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()
	const { checkAuth } = useCheckAuth()
	useEffect(() => {
		checkAuth()
			.then((userInfo) => {
				if (userInfo === null && !['/signin', '/signup', '/test'].includes(pathname)) {
					navigate('/signin')
				}
			})
			.catch(() => {})
	}, [checkAuth, navigate, pathname])
	return null
}

export default AuthChecker
